'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _illustrationName = require('../utils/propTypes/illustrationName');

var _UIAbstractIllustration = require('./UIAbstractIllustration');

var _UIAbstractIllustration2 = _interopRequireDefault(_UIAbstractIllustration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIIllustration = function UIIllustration(props) {
  return _react2.default.createElement(_UIAbstractIllustration2.default, props);
};

UIIllustration.defaultProps = _UIAbstractIllustration2.default.defaultProps;
UIIllustration.propTypes = _extends({}, _UIAbstractIllustration2.default.propTypes, {
  name: (0, _illustrationName.getIllustrationNamePropType)().isRequired
});

UIIllustration.displayName = 'UIIllustration';

exports.default = UIIllustration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/image/UIIllustration.js
// module id = 131
// module chunks = 0